<template>
  <div v-loading="$wait.waiting(_uid)" class="card training-program">
    <div class="card-content">

      <acl :tier="['premium']">
        <TrainingRecordExpiryNotes />
      </acl>

      <div class="flex lg:flex-row flex-col justify-between">
        <acl>
          <div class="flex lg:flex-row flex-col">
            <div class="lg:flex-row">
              <div class="flex ml-auto">
                <b class="mr-3">Display record for:</b>
                <el-date-picker
                  v-model="searchDate"
                  :picker-options="datePickerOptions"
                />
              </div>
            </div>
            <div class="flex ml-auto xs:flex-row xs-margin">
              <button
                type="button"
                class="ml-3 btn btn-warning btn-wd submit-button lg:w-auto w-full xs:ml-8"
                @click="generate"
              >
                Generate
              </button>
            </div>
          </div>
        </acl>

        <div class="flex ml-auto mt-auto">
          <acl :tier="['premium']">
            <div class="flex lg:flex-row flex-col">
              <button
                type="button"
                class="ml-3 btn btn-primary btn-wd submit-button lg:w-auto w-full xs:ml-8 hidden"
                @click="changeVersion"
              >
                <div v-if="version == 1">Cycle Version</div>

                <div v-if="version == 4">Old Version</div>
              </button>

              <drop-down v-if="!user.international_procedures">
                <button
                  slot="title"
                  class="btn btn-cancel btn-info btn-wd submit-button lg:w-auto w-full dropdown-toggle"
                  data-toggle="dropdown"
                >
                  Print
                  <b class="caret"></b>
                </button>
                <li>
                  <a @click="download('complete')">Complete (Collapsed)</a>
                </li>
                <li>
                  <a @click="download('complete_expanded')">Complete (Expanded)</a>
                </li>
              </drop-down>

              <drop-down v-if="user.international_procedures">
                <button
                  slot="title"
                  class="btn btn-cancel btn-info btn-wd submit-button lg:w-auto w-full dropdown-toggle"
                  data-toggle="dropdown"
                >
                  Print
                  <b class="caret"></b>
                </button>
                <li>
                  <a @click="download('complete')">Complete (Collapsed)</a>
                </li>
                <li>
                  <a @click="download('complete_expanded')">Complete (Expanded)</a>
                </li>
                <li>
                  <a @click="download('international_procedures')">International Procedures</a>
                </li>
              </drop-down>
            </div>
          </acl>
        </div>
      </div>

      <div class="mt-5 row">
        <div class="col-sm-12">
          <acl :tier="['premium']">
            <PremiumTrainingRecord :data="records" :version="version" />
          </acl>
          <acl :tier="['essentials']">
            <EssentialsTrainingRecord
              :data="records"
              @printCertificate="printCertificate"
              @downloadCertificate="downloadCertificate"
            />
          </acl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import PremiumTrainingRecord from "@/components/Dashboard/Views/Pages/Training/Record/Components/PremiumTrainingRecord";
import EssentialsTrainingRecord from "@/components/Dashboard/Views/Pages/Training/Record/Components/EssentialsTrainingRecord";
import { mapGetters, mapActions } from "vuex";
import HelperDate from "@helpers/dates";
import { saveAs } from "file-saver";
import _kebabCase from "lodash.kebabcase";
import TrainingRecordExpiryNotes from "../../../Training/Record/TrainingRecordExpiryNotes.vue";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    PremiumTrainingRecord,
    EssentialsTrainingRecord,
    TrainingRecordExpiryNotes,
  },
  data() {
    const disabledDate = this.disabledDate;
    return {
      searchDate: this.moment(),
      datePickerOptions: {
        disabledDate,
      },
      minDate: this.moment(),
      maxDate: this.moment(),
      version: null,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyUserStore", ["user", "records"]),
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);

      // const migrationDate = this.moment(this.user.migration_date).startOf("day");
      // const createdAt = this.moment(this.user.created_at).startOf("day");
      // this.mimDate = createdAt < migrationDate ? createdAt : migrationDate;
      // this.mimDate = createdAt;

      this.mimDate = this.moment().subtract(3, "years").startOf("day");

      const endDay = this.moment().endOf("day");
      this.maxDate = this.user.deleted_at
        ? this.moment(this.user.deleted_at).endOf("day")
        : endDay;

      console.log({
        mimDate: this.mimDate.utc().format("YYYY-MM-DD"),
        maxDate: this.maxDate.utc().format("YYYY-MM-DD"),
      });

      this.searchDate = this.maxDate;

      this.version = this.user.training_record;

      const params = {
        userId: this.user.id,
        date: this.parseDate(this.searchDate),
        version: this.version,
      };

      await this.getUserRecords(params);

      this.records;
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("companyUserStore", [
      "getUserRecords",
      "getUserRecordsDownload",
      "getUserCertificateDownload",
    ]),
    ...mapActions("errorStore", ["addNewError"]),
    async generate() {
      try {
        this.$wait.start(this._uid);
        const params = {
          userId: this.user.id,
          date: this.parseDate(this.searchDate),
          version: this.version,
        };
        await this.getUserRecords(params);
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    parseDate(date) {
      return HelperDate.formatDate(date);
    },
    print() {
      const routeData = this.$router.resolve({
        name: "companies_users@records-print",
        params: { id: this.user.id },
        query: { date: this.parseDate(this.searchDate), version: this.version },
      });
      window.open(routeData.href, "_blank");
    },
    async download(type) {
      try {
        this.$wait.start(this._uid);
        const date = this.parseDate(this.searchDate);
        const version = this.version;
        const filename = _kebabCase(`${this.user.fullName}-${date}`);
        const filetype = "application/pdf;charset=utf-8";

        const params = {
          userId: this.user.id,
          date: date,
          version: version,
          type: type,
        };

        const response = await this.getUserRecordsDownload(params);

        const blob = new Blob(
          [response.data],
          { type: filetype },
          { autoBom: true }
        );
        saveAs(blob, filename);
      } catch (error) {
        this.addNewError(error);
        this.$wait.end(this._uid);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    async printCertificate(certificate) {
      const routeData = this.$router.resolve({
        name: "companies_users@certificate_print",
        params: { id: this.user.id, hash: certificate.hash },
        query: { date: this.parseDate(this.searchDate), version: this.version },
      });
      window.open(routeData.href, "_blank");
    },
    async downloadCertificate(certificate) {
      try {
        this.$wait.start(this._uid);
        const date = this.parseDate(this.searchDate);
        const filename = _kebabCase(`${this.user.fullName}-${date}`);
        const type = "application/pdf;charset=utf-8";

        const params = {
          userId: this.user.id,
          hash: certificate.hash,
        };

        const response = await this.getUserCertificateDownload(params);
        const blob = new Blob(
          [response.data],
          { type: type },
          { autoBom: true }
        );
        saveAs(blob, filename);
      } catch (error) {
        this.addNewError(error);
        this.$wait.end(this._uid);
      } finally {
        this.$wait.end(this._uid);
      }
    },
    disabledDate(date) {
      return !(this.mimDate <= date && date <= this.maxDate);
    },
    async changeVersion() {
      try {
        this.$wait.start(this._uid);

        if (this.version == 1) {
          this.version = 4;
          await this.generate();
          return;
        }

        if (this.version == 4) {
          this.version = 1;
          await this.generate();
          return;
        }
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss">
.dropdown-menu:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 55px !important;
  top: -12px;
}

.dropdown-menu:before {
  border-bottom: 11px solid #f1eae0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 55px !important;
  top: -12px;
}

.dropdown-menu {
  left: -35px;
}
@media (max-width: 767px) {
  .xs-margin {
    margin-top: 10px;
  }
}
</style>
